// frontend/src/pages/PayrollDone/styles.ts
// Palette + reusable style objects for the Payroll Done page.

import type { CSSProperties } from "react";

// ── Palette ─────────────────────────────────────────────────────────────
export const C = {
  ink: "#12262B",
  inkDark: "#0E1A1A",
  brand: "#15A08C",
  brandDark: "#0F6E56",
  brandBg: "#E1F5EE",
  page: "#F4F6F8",
  card: "#FFFFFF",
  line: "#E7EAF0",
} as const;

export const FONT = "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

/** Shared "tabular numerals" style spread into cells with numbers. */
export const tabular: CSSProperties = { fontVariantNumeric: "tabular-nums" };

// ── Reusable buttons ────────────────────────────────────────────────────
/** White bg + ink border. Used for secondary actions (Back, Export CSV, Print pay stubs). */
export const outlineBtn: CSSProperties = {
  padding: "12px 18px",
  background: C.card,
  border: "1.5px solid " + C.ink,
  borderRadius: 10,
  color: C.ink,
  fontSize: 14,
  fontWeight: 700,
  cursor: "pointer",
  fontFamily: FONT,
};

/** Smaller outline button for inline step actions ("Print pay stubs" in NextSteps). */
export const outlineBtnSmall: CSSProperties = {
  padding: "8px 14px",
  background: C.card,
  border: "1.5px solid " + C.ink,
  borderRadius: 8,
  color: C.ink,
  fontSize: 13,
  fontWeight: 700,
  cursor: "pointer",
  fontFamily: FONT,
};

/** Solid brand teal with white text. Used for the primary "Print all pay stubs" action. */
export const primaryBtn: CSSProperties = {
  padding: "12px 24px",
  background: C.brand,
  border: "none",
  borderRadius: 10,
  color: C.card,
  fontSize: 14,
  fontWeight: 700,
  cursor: "pointer",
  fontFamily: FONT,
  boxShadow: "0 1px 2px rgba(18,38,43,0.12)",
};

/** Text-only button in brand teal. Used for "View liabilities". */
export const textBtn: CSSProperties = {
  padding: "8px 14px",
  background: "transparent",
  border: "none",
  color: C.brandDark,
  fontSize: 13,
  fontWeight: 700,
  cursor: "pointer",
  fontFamily: FONT,
};

/** Cheque number input in the employee table. */
export const chequeInput: CSSProperties = {
  width: "100%",
  border: "1.5px solid " + C.ink,
  borderRadius: 8,
  padding: "8px 12px",
  fontSize: 13,
  color: C.ink,
  background: C.card,
  fontFamily: FONT,
};

// ── Section headings ────────────────────────────────────────────────────
/** The uppercase column/section label used throughout the page. */
export const sectionLabel: CSSProperties = {
  fontSize: 11,
  fontWeight: 700,
  color: C.ink,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  marginBottom: 6,
};